import { render } from "./index.vue?vue&type=template&id=568998bd&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=568998bd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-568998bd"

export default script